stableOptions